import ProfileModel from './profile-model';
import jsonProfile from './profile-pictures/json.jpeg';

const jackson = new ProfileModel({
    username: '9',
    password: 'admin',
    profilePicture: jsonProfile,
    firstName: 'Jackson',
    lastName: 'Strambi',
    files: [
        "//v2.grommet.io/assets/Wilderpeople_Ricky.jpg"
    ],
    key: 2,
})

export default jackson;